import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { deletePost, getPost, createPost, updatePost } from '../../../redux/actions/post';
import { Button, Table, Modal, Form, Input, message, Upload, Image } from 'antd';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ProtectedLayout from '../../../layouts/ProtectedLayout';
import type { UploadFile } from 'antd/es/upload/interface';

const Posts = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { posts, loading } = useSelector((state: any) => state.posts);
  const [oModal, setOmaodal] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalAction, setModalAction] = useState('');
  const [textAreaValue, setTextAreaValue] = useState('');
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const auth = JSON.parse(localStorage.getItem('auth') || '{}');

  useEffect(() => {
    (dispatch as any)(getPost());
  }, [dispatch]);

  const handleDelete = (record) => {
    alert(`${record.title} postunu silmek istediğinize emin misiniz?`)
    dispatch<any>(deletePost(record._id));
  };

  const handleUpdate = (record) => {
    if (record.headerImage || record.blogImage) {
      const files: UploadFile[] = [];
      if (record.headerImage) {
        files.push({
          uid: '-1',
          name: 'header-image',
          status: 'done',
          url: `${record.headerImage}`
        });
      }
      if (record.blogImage) {
        files.push({
          uid: '-2',
          name: 'blog-image',
          status: 'done',
          url: `${record.blogImage}`
        });
      }
      setFileList(files);
    }

    form.setFieldsValue({
      ...record,
      description: record.description,
      shortDescription: record.shortDescription
    });
    setTextAreaValue(record.description);
    openModal('Post Düzenle', 'Update', record);
  }

  const handleSubmit = async (values) => {
    console.log(values)
    try {
      const formData = new FormData();
      
      fileList.forEach((file: any) => {
        if (file.originFileObj) {
          if (fileList.indexOf(file) === 0) {
            formData.append('headerImage', file.originFileObj);
          } else {
            formData.append('blogImage', file.originFileObj);
          }
        }
      });

      formData.append('title', values.title);
      formData.append('shortDescription', values.shortDescription);
      formData.append('description', textAreaValue);
      formData.append('user', auth.user.username);

      if (modalAction === 'Update') {
        formData.append('_id', values._id);
        await dispatch<any>(updatePost(values._id, formData));
        message.success('Post başarıyla güncellendi');
      } else if (modalAction === 'Add') {
        await dispatch<any>(createPost(formData));
        message.success('Post başarıyla oluşturuldu');
      }
      closeModal();
      dispatch<any>(getPost());
    } catch (error) {
      console.error('Form gönderme hatası:', error);
      message.error('Bir hata oluştu');
    }
  };

  const openModal = (title: string, action: 'Add' | 'Update', data?: any) => {
    setModalTitle(title);
    setModalAction(action);
    setOmaodal(true);
  };

  const closeModal = () => {
    setOmaodal(false);
    form.resetFields();
    setTextAreaValue('');
    setFileList([]);
  };

  const columns: any = [
    {
      title: 'Resim',
      dataIndex: 'headerImage',
      key: 'headerImage',
      render: (text: string, record: any) => (
        <Image src={`${record.blogImage}`} width={100} height={100} className='rounded-md shadow-md object-cover' />
      )
    },
    {
      title: 'Başlık',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Yazar',
      dataIndex: 'user',
      key: 'user',
    },
    {
      title: 'Tarih',
      dataIndex: 'date',
      key: 'date',
      render: (date: string) => new Date(date).toLocaleDateString('tr-TR')
    },
    {
      title: '',
      key: 'actions',
      align: 'right',
      render: (_, record) => (
        <div className="space-x-2">
          <Button type="primary" onClick={() => handleUpdate(record)}>
            Düzenle
          </Button>
          <Button danger onClick={() => handleDelete(record)}>
            <DeleteOutlined />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <ProtectedLayout>
      <div className="p-4">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold">Posts</h1>
          <Button type="primary" onClick={() => openModal('Yeni Post Ekle', 'Add')}>
            Yeni Post Ekle
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={posts}
          rowKey="_id"
          loading={loading}
        />

        <Modal open={oModal} onCancel={closeModal} footer={null} title={modalTitle} width={"50%"}>
          <Form
            form={form}
            onFinish={handleSubmit}
            labelAlign='left'
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Form.Item label="ID" name="_id" className='hidden'>
              <Input disabled />
            </Form.Item>
            <Form.Item
              label="Post Resimleri"
              name="images"
              rules={[{ 
                validator: (_, value) => {
                  if (fileList.length === 0) {
                    return Promise.reject('Lütfen en az bir resim yükleyin');
                  }
                  return Promise.resolve();
                }
              }]}
            >
              <Upload
                listType="picture-card"
                fileList={fileList}
                onChange={({ fileList }) => {
                  setFileList(fileList);
                  form.setFieldsValue({ images: fileList });
                }}
                beforeUpload={() => false}
                maxCount={2}
                accept="image/*"
              >
                {fileList.length >= 2 ? null : (
                  <div>
                    <UploadOutlined />
                    <div style={{ marginTop: 8 }}>Yükle</div>
                  </div>
                )}
              </Upload>
              <div className="text-sm text-gray-500 mt-2">
                İlk yüklenen resim başlık resmi, ikinci resim blog resmi olarak kullanılacaktır.
              </div>
            </Form.Item>
            <Form.Item label="Başlık" name="title">
              <Input />
            </Form.Item>
            <Form.Item 
              label="Kısa Açıklama" 
              name="shortDescription"
              rules={[
                { required: true, message: 'Lütfen kısa açıklama giriniz' },
                { max: 200, message: 'Kısa açıklama en fazla 200 karakter olabilir' }
              ]}
            >
              <Input.TextArea maxLength={200} showCount />
            </Form.Item>
            <Form.Item label="İçerik" name="description">
              <ReactQuill 
                theme="snow" 
                value={textAreaValue} 
                onChange={setTextAreaValue}
              />
            </Form.Item>
            <Form.Item label="Yazar" name="user">
              <Input disabled placeholder={auth.user.username} value={auth.user.username} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Kaydet
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </ProtectedLayout>
  );
};

export default Posts;